import React, { FC } from "react"
import { Flex, Heading } from "@chakra-ui/react"

import { NextButton } from "~/components/shared/NextButton"
import { IfTTExists, TT, TTString } from "~/components/shared/AttributedString"
import { BasePageWrapper } from "~/components/shared/BasePageWrapper/BasePageWrapper"
import { RiveAlignment, RiveOrImage } from "~/components/shared/RiveImage"

export const MessageWithImagePage: FC<{
  title: TTString
  image: string | undefined
  next: () => void
}> = ({ title, image, next }) => {
  return (
    <BasePageWrapper h="full" paddingBottom={4} gap={6}>
      {image && (
        <RiveOrImage width="full" src={image} ratio={1.3} alignment={RiveAlignment.Center} />
      )}
      <IfTTExists if={title}>
        <Heading textAlign="left" as="h1" size="Header/Primary">
          <TT>{title}</TT>
        </Heading>
      </IfTTExists>
      <Flex flexGrow={1} justifyContent="flex-end" alignItems="flex-end">
        <NextButton onClick={next} />
      </Flex>
    </BasePageWrapper>
  )
}
